import { createNamespacedHelpers, Module } from "vuex";
import { state } from "./state";
import { getters } from "./getters";
import { mutations } from "./mutations";
import { actions } from "./actions";
import {
  RoofStructureState,
  RoofStructureGetters,
  RoofStructureMutations,
  RoofStructureActions
} from "./types";

const namespaced = true;
export const namespace = "roofStructure";

export const {
  mapState: roofStructureMapState,
  mapGetters: roofStructureMapGetters,
  mapMutations: roofStructureMapMutations,
  mapActions: roofStructureMapActions
} = createNamespacedHelpers<
  RoofStructureState,
  RoofStructureGetters,
  RoofStructureMutations,
  RoofStructureActions
>(namespace);

export const roofStructure: Module<RoofStructureState, any> = {
  namespaced,
  state,
  getters,
  mutations,
  actions
};
